"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PrimeBannerStatus=void 0;var t;(function(e){e.Checked="CHECKED",e.NotChecked="NOT_CHECKED",e.NotPresent="NOT_PRESENT"})(t||(exports.PrimeBannerStatus=t={}));
//# sourceMappingURL=PrimeBannerStatus.js.map
